/**
 *
 * Checkout
 *
 */
import { Col, Divider, Form, Row } from 'antd';
import { ReactComponent as CloseIcon } from 'app/assets/img/close_icon.svg';
import { LoadingContainer } from 'app/components/LoadingContainer';
import ModalContainer from 'app/components/ModalContainer';
import {
  CheckoutDetail,
  Orderdate,
} from 'app/pages/Restaurants/Checkout/slice/types';
import { getReservationBookingDetailApi } from 'app/services/reservationHistoryApi';
import React, { memo, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { formatNumber, windowOpenLink } from 'utils/helper';
import {
  CountdownTimer,
  IntervalTimer,
  isTimeValid,
  parseSecondsToMinutesAndHours,
} from 'utils/time';
import {
  selectIsLogged,
  selectTranslations,
} from 'app/pages/App/slice/selectors';
import { CheckoutWrapper } from './styled';
import { isNil } from 'lodash';
import moment from 'moment';
import { ReactComponent as CopyIcon } from 'app/assets/img/copy-icon.svg';
import { notify } from 'reapop';
import StyledButton from 'app/components/StyledButton';
import DialogWarning from 'app/pages/Catalog/components/DialogWarning';
import { TimeoutModal } from './ConfirmPolicyOrder';
import useCountDown from 'utils/hooks/useCountDown';
import Images from 'app/assets/img';
import { QRCodeCanvas } from 'qrcode.react';
import { mapReservationDetailToCheckout } from './hooks/useCheckout';

interface Props {}

const replacePaymentWithSpan = (
  text: string,
  replaceText: string,
  replaceTo: React.ReactNode,
  style: React.CSSProperties = {},
) => {
  const parts = text.split(replaceText);

  const newText = parts.map((part, index) => (
    <>
      {part}
      {index < parts.length - 1 && <span style={style}>{replaceTo}</span>}
    </>
  ));

  return <>{newText}</>;
};

export const NcbPayment = memo((props: Props) => {
  const translations = useSelector(selectTranslations);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const [order, setOrder] = useState<CheckoutDetail>();
  const [expiredHours, setExpiredHours] = useState<any>();
  const [qrImage, setQrImage] = useState<string>();
  const [isValidPaymentTime, setIsValidPaymentTime] = useState<boolean>(true);
  const intervalTimerRef = useRef<IntervalTimer>();
  // const countDownTimerRef = useRef<CountdownTimer>();
  const [countdownShow, setCountdownShow] = useState(false);
  const [countdownTime, setCountdownTime] = useState('00:00:00');
  const [isShowDialogWarning, setIsShowDialogWarning] = useState(false);
  const [messageWarning, setMessageWarning] = useState('');
  const dispatch = useDispatch();
  const [bankInfo, setBankInfo] = useState<{
    bankAccount: string;
    bankName: string;
    accountName?: string;
  }>();
  const history = useHistory();

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        setLoading(true);
        const {
          id,
          qrImage: qrImageData,
          bankInfo,
        } = location.state as {
          id: string;
          qrImage: string;
          bankInfo: {
            bankAccount: string;
            bankName: string;
            accountName?: string;
          };
        };
        const { data } = await getReservationBookingDetailApi({
          reservationNo: id,
        });
        const detailOrder = mapReservationDetailToCheckout(data, id);
        const hourFrom = detailOrder?.payment?.validFrom;
        const hourTo = detailOrder?.payment?.validTo;
        const isValidPayment = isTimeValid(hourFrom, hourTo);
        setIsValidPaymentTime(!hourFrom && !hourTo ? true : isValidPayment);
        const expiredHours = getTimeRemainingLabel(
          detailOrder?.expiredAt,
          detailOrder?.startTime,
        );
        setExpiredHours(expiredHours);
        setOrder(detailOrder);
        setQrImage(qrImageData);
        setBankInfo(bankInfo);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    fetchOrder();
  }, [location.state]);

  useEffect(() => {
    const listener = async () => {
      try {
        const { id } = location.state as {
          id: string;
        };
        const { data } = await getReservationBookingDetailApi({
          reservationNo: id,
        });
        const detailOrder = mapReservationDetailToCheckout(data, id);
        const stopInterval = () => {
          intervalTimerRef.current?.stop();
          // countDownTimerRef.current?.stop();
        };
        if (
          ['paymentPending', 'OnHold', 'onHold'].includes(
            detailOrder.orderState.value,
          ) ||
          (detailOrder.orderState.value === 'init' &&
            !!detailOrder.adjustedPriceOrFOC)
        ) {
          if (detailOrder.paymentError) {
            stopInterval();
            setIsShowDialogWarning(true);
            setMessageWarning(detailOrder.paymentError);
            return;
          }
          return;
        }
        stopInterval();
        intervalTimerRef.current?.stop();
        if (detailOrder.orderState.value === 'success') {
          windowOpenLink({
            url: `/restaurants/payment-callback?vnp_TxnRef=${detailOrder?.idHash}&bnPaymentType=${detailOrder.payment?.code}&result_code=1`,
            target: '_self',
          });
        } else {
          windowOpenLink({
            url: `/restaurants/payment-callback?vnp_TxnRef=${detailOrder?.idHash}&bnPaymentType=${detailOrder.payment?.code}&result_code=0`,
            target: '_self',
          });
        }
      } catch (error) {
        intervalTimerRef.current?.stop();
      }
    };
    if (!intervalTimerRef.current) {
      intervalTimerRef.current = new IntervalTimer(15000);
      intervalTimerRef.current.start();
    }
    intervalTimerRef.current.addListener(listener);

    return () => {
      intervalTimerRef.current?.removeListener(listener);
    };
  }, [location.state]);

  useEffect(() => {
    return () => {
      intervalTimerRef.current?.stop();
    };
  }, []);

  // useEffect(() => {
  //   if (isNil(order)) {
  //     return;
  //   }
  //   const timeRemaining =
  //     moment(
  //       order?.expiredAt?.datetimeDMYHIS ?? undefined,
  //       'HH:mm:ss DD/MM/YYYY',
  //     ).valueOf() -
  //     moment(
  //       order?.startTime?.datetimeDMYHIS ?? undefined,
  //       'HH:mm:ss DD/MM/YYYY',
  //     ).valueOf();
  //   const countDownSecond = timeRemaining / 1000;

  //   if (countDownSecond <= 0) {
  //     setCountdownShow(true);
  //     return;
  //   }
  //   const onTickListener = (time: number) => {
  //     const { minutes, seconds, hours } = parseSecondsToMinutesAndHours(time);
  //     setCountdownTime(
  //       `${hours < 10 ? '0' : ''}${hours}:${
  //         minutes < 10 ? '0' : ''
  //       }${minutes}:${seconds < 10 ? '0' : ''}${seconds}`,
  //     );
  //   };
  //   const endListener = () => {
  //     setCountdownShow(true);
  //   };
  //   if (!countDownTimerRef.current) {
  //     countDownTimerRef.current = new CountdownTimer(
  //       parseInt(`${countDownSecond}`),
  //     );
  //     countDownTimerRef.current.start(1000, onTickListener);
  //   }
  //   countDownTimerRef.current.addListener(endListener);

  //   return () => {
  //     countDownTimerRef.current?.removeListener(endListener);
  //   };
  // }, [order]);

  // useEffect(() => {
  //   return () => {
  //     countDownTimerRef.current?.stop();
  //   };
  // }, []);
  const getTimeRemainingLabel = (targetTime: Orderdate, startOfTime) => {
    const expiredAt = moment(
      targetTime?.datetimeDMYHIS ?? undefined,
      'HH:mm:ss DD/MM/YYYY',
    );
    const now = moment();
    const diffMsFromNow = expiredAt.valueOf() - now.valueOf();
    if (diffMsFromNow <= 0) return undefined;
    const startTime = moment(
      startOfTime?.datetimeDMYHIS ?? undefined,
      'HH:mm:ss DD/MM/YYYY',
    );
    const time = expiredAt.valueOf() - startTime.valueOf();
    // Quy đổi ra giờ (bao gồm phần lẻ)
    const diffHours = time / (1000 * 60 * 60);
    // Làm tròn 1 chữ số thập phân (ví dụ: 1.3h)
    let roundedHours = Math.round(diffHours * 10) / 10;
    if (diffHours < 3 / 60) {
      roundedHours = Number(diffHours.toFixed(2));
    }
    return roundedHours;
  };
  return (
    <CheckoutWrapper id="bookticketspay" className="main">
      <div className="bookticketspayContent bookticketsContent checkOut">
        <div className="container">
          <LoadingContainer isFullPage loading={loading}>
            <div className="row">
              <div className="col-xl-12">
                <>
                  <div className="checkOutInfo">
                    <div>
                      <HeaderContainer>
                        <div />
                        <Title>
                          {translations
                            ? translations[
                                'b2c.txt.create-order-number'
                              ]?.replaceAll('${number}', `${order?.id ?? ''}`)
                            : ''}
                        </Title>
                      </HeaderContainer>
                      {!!order?.adjustedPriceOrFOC &&
                      order?.expiredAt === null ? null : (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                          }}
                        >
                          <h5
                            style={{
                              fontSize: '14px',
                              fontWeight: '600',
                            }}
                          >
                            {translations ? translations['b2c.txt.payIn'] : ''}{' '}
                            {/* <span
                              style={{ color: '#E92127' }}
                            >{`${countdownTime}`}</span> */}
                            {order?.expiredAt && (
                              <Countdown
                                onTimeout={() => setCountdownShow(true)}
                                orderCheckout={order}
                              />
                            )}
                          </h5>
                        </div>
                      )}
                    </div>
                    {!!order?.adjustedPriceOrFOC &&
                    order?.expiredAt === null ? null : (
                      <Description>
                        {order?.expiredAt ? (
                          <>
                            {translations
                              ? replacePaymentWithSpan(
                                  translations[
                                    'b2c.txt.pay-order-ncb-description'
                                  ],
                                  '${payment}',
                                  order?.payment?.name ?? '',
                                  { fontWeight: 'bold' },
                                )
                              : ''}{' '}
                            {translations
                              ? replacePaymentWithSpan(
                                  translations[
                                    'b2c.txt.pay-order-description-1'
                                  ],
                                  '${hour}',
                                  <Countdown orderCheckout={order} />,
                                  { color: '#E92127' },
                                )
                              : ''}
                          </>
                        ) : (
                          <>
                            {translations &&
                              replacePaymentWithSpan(
                                translations['b2c.txt.pay-order-description'],
                                '${payment}',
                                translations['b2b.txt.bank-transfer'],
                                {
                                  fontWeight: 'bold',
                                  textTransform: 'uppercase',
                                },
                              )}
                            {'. '}
                            {translations
                              ? translations['b2b.txt.pay-order-description-2']
                              : ''}
                          </>
                        )}
                      </Description>
                    )}
                  </div>
                  <div className="checkOutInfo">
                    <HeaderContainer>
                      <div />
                      <Title style={{ textAlign: 'center' }}>
                        {translations
                          ? translations['b2b.txt.paymentGuide']
                          : ''}
                      </Title>
                      <div />
                    </HeaderContainer>
                    <Description>
                      {translations
                        ? replacePaymentWithSpan(
                            translations['b2b.txt.note-transfer-money-ncb'],
                            '${totalPrice}',
                            `${formatNumber(
                              order?.orderType?.value === 'upgrade'
                                ? order?.differenceAmount ?? 0
                                : order?.totalPrice ?? 0,
                            )} đ`,
                            { fontWeight: 'bold', color: '#E92127' },
                          )
                        : ''}
                    </Description>
                    <div
                      className="--sub-title"
                      style={
                        isValidPaymentTime
                          ? { margin: '17px 0px', fontWeight: 'bold' }
                          : { fontStyle: 'normal', textAlign: 'center' }
                      }
                    >
                      {isValidPaymentTime ? (
                        <>
                          <span>{'('}</span>
                          <span style={{ color: 'red' }}>{'*'}</span>
                          <span>{')'}</span>{' '}
                          {translations
                            ? `${translations['b2b.txt.ncb-note-transfer-money']}`
                            : ''}
                        </>
                      ) : translations ? (
                        `${translations['b2b.txt.note-transfer-money-invalid']}`
                      ) : (
                        ''
                      )}
                    </div>
                    {isValidPaymentTime && qrImage && (
                      <>
                        <ImgWrapper>
                          <div
                            className="d-flex justify-content-center flex-column align-items-center"
                            style={{
                              width: 250,
                              margin: 'auto',
                            }}
                          >
                            <img
                              src={Images.iconNcbLogo}
                              alt="ncb logo"
                              style={{
                                marginBottom: 3,
                                height: 28,
                              }}
                            />
                            {/^https?:\/\//i.test(qrImage) ||
                            qrImage.startsWith('data:image') ? (
                              <StyledImg src={qrImage} alt="" />
                            ) : (
                              <QRCodeCanvas
                                value={qrImage}
                                level="H"
                                size={250}
                              />
                            )}
                            <div className="d-flex align-items-center justify-content-between w-100">
                              <img
                                src={Images.vietQRPay}
                                alt="vietQRPay logo"
                                style={{
                                  height: 50,
                                  width: 110,
                                }}
                              />
                              <Divider
                                type="vertical"
                                style={{
                                  backgroundColor: '#adacb0',
                                  height: 25,
                                }}
                              />
                              <img
                                src={Images.vietQRGlobal}
                                alt="vietQRGlobal logo"
                                style={{
                                  marginRight: 10,
                                  width: 100,
                                  marginLeft: 10,
                                }}
                              />
                            </div>
                          </div>
                        </ImgWrapper>
                        <div style={{ margin: '8px 0px' }}>
                          {translations?.['b2b.txt.ncb-note-1'] ?? ''}
                        </div>
                        <Row
                          nz-row
                          className="d-flex txt-content"
                          style={{ marginBottom: 8 }}
                        >
                          <Col xs={8} md={4} style={{ fontWeight: 'normal' }}>
                            {translations
                              ? `${translations['b2b.txt.bank-account']}: `
                              : ''}
                          </Col>
                          <Col xs={14} md={18}>
                            {bankInfo?.bankAccount}
                            <CopyIcon
                              style={{
                                cursor: 'pointer',
                                width: 16,
                                height: 16,
                                margin: '0px 8px',
                              }}
                              onClick={() => {
                                navigator.clipboard.writeText(
                                  bankInfo?.bankAccount ?? '',
                                );
                                dispatch(
                                  notify('', 'success', {
                                    title: 'Copied',
                                    dismissAfter: 2000,
                                  }),
                                );
                              }}
                            />
                          </Col>
                        </Row>
                        <Row
                          nz-row
                          className="d-flex txt-content"
                          style={{ marginBottom: 8 }}
                        >
                          <Col xs={8} md={4} style={{ fontWeight: 'normal' }}>
                            {translations
                              ? `${translations['b2c.txt.bank']}: `
                              : ''}
                          </Col>
                          <Col xs={14} md={18}>
                            {translations?.['b2c.txt.ncb-bank-name']}
                          </Col>
                        </Row>
                        <Row
                          nz-row
                          className="d-flex txt-content"
                          style={{ marginBottom: 8 }}
                        >
                          <Col xs={8} md={4} style={{ fontWeight: 'normal' }}>
                            {translations
                              ? `${translations['b2c.txt.bank-name']}: `
                              : ''}
                          </Col>
                          <Col xs={14} md={18}>
                            {bankInfo?.accountName ?? bankInfo?.bankName}
                          </Col>
                        </Row>
                        <Row nz-row className="d-flex txt-content">
                          <Col xs={8} md={4} style={{ fontWeight: 'normal' }}>
                            {translations
                              ? `${translations['b2c.txt.modal-ticket-content']}: `
                              : ''}
                          </Col>
                          <Col xs={14} md={18}>
                            {order?.id}
                            <CopyIcon
                              style={{
                                cursor: 'pointer',
                                width: 16,
                                height: 16,
                                margin: '0px 8px',
                              }}
                              onClick={() => {
                                navigator.clipboard.writeText(
                                  `${order?.id ?? ''}`,
                                );
                                dispatch(
                                  notify('', 'success', {
                                    title: 'Copied',
                                    dismissAfter: 2000,
                                  }),
                                );
                              }}
                            />
                            <span
                              style={{
                                fontWeight: 'normal',
                              }}
                            >
                              {translations?.['b2b.txt.ncb-your-order']}
                            </span>
                          </Col>
                        </Row>
                      </>
                    )}
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        marginTop: 16,
                      }}
                    >
                      <StyledButton
                        bgColor="white"
                        border="1px solid #808080"
                        textColor="#808080"
                        height={'44px'}
                        onClick={() =>
                          windowOpenLink({
                            url: '/account',
                            target: '_self',
                          })
                        }
                        style={{
                          width: 'auto',
                          minWidth: 160,
                        }}
                      >
                        {translations
                          ? translations['b2b.txt.back-to-history']
                          : ''}
                      </StyledButton>
                    </div>
                  </div>
                </>
              </div>
            </div>
          </LoadingContainer>
        </div>
      </div>
      <TimeoutModal
        open={countdownShow}
        onClose={() => {
          history.push(
            '/restaurants/payment-callback?vnp_TxnRef=' + order?.idHash,
          );
        }}
      />
      {isShowDialogWarning && (
        <DialogWarning
          open={isShowDialogWarning}
          maskClosable={false}
          onClose={() => history.push('/account')}
          message={messageWarning}
        />
      )}
    </CheckoutWrapper>
  );
});

const Policy = styled.div`
  background: #ffffff;
  overflow: auto;
  height: 600px;
  ::-webkit-scrollbar {
    width: 6px; /* Width of the scrollbar */
  }

  /* Define the track (the area behind the thumb) */
  ::-webkit-scrollbar-track {
    background: transparent; /* Color of the track */
  }

  /* Define the scrollbar thumb */
  ::-webkit-scrollbar-thumb {
    background: #ececec; /* Color of the thumb */
    border-radius: 20px;
  }

  /* Define the scrollbar thumb on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #d6d6d6; /* Color of the thumb on hover */
  }
`;

const StyledPolicy = styled.div`
  border-radius: 20px;
  background: #ffffff;
  /* height: 301px; */
  padding: 24px 20px;
  border: 1px solid #d9d9d9;
  color: #000000;
  margin-top: 12px;
`;

const Title = styled.h4`
  margin: 0;
  font-weight: 600;
  color: #000000;
  font-size: 24px;
  text-transform: capitalize;
`;

const Description = styled.p`
  font-weight: 400;
  color: #000000;
  font-size: 14px;
  text-align: left;
  margin-top: 14px;
  line-height: 1.7rem;
`;

const HeaderContainer = styled.div`
  margin: 10px 0px;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  justify-content: center;
  color: #000000;
`;
const SubHeaderContainer = styled.div`
  margin: 10px 0px;
  display: flex;
  color: #000000;
  font-size: 16px;
  font-weight: 600;
`;

const StyledDivider = styled(Divider)`
  margin: 14px 0px 14px 0px;
  width: 100%;
  min-width: 100%;
`;
const ImgWrapper = styled.div`
  width: 100%;
  border-radius: 16px;
  overflow: hidden;
`;
const StyledImg = styled.img`
  width: 250px;
  max-width: 100%;
  height: 'auto';
  display: 'flex';
  justify-content: 'center';
  object-fit: cover;
  &[src=''] {
    opacity: 0;
  }
`;
export const Countdown = ({
  onTimeout,
  orderCheckout,
}: {
  onTimeout?: () => void;
  orderCheckout?: CheckoutDetail;
  noText?: boolean;
}) => {
  const isTimeout = useRef(false);
  const expiredAt = moment(
    orderCheckout?.expiredAt?.datetimeDMYHIS ?? undefined,
    'HH:mm:ss DD/MM/YYYY',
  );
  const startTime = moment(
    orderCheckout?.startTime?.datetimeDMYHIS ?? undefined,
    'HH:mm:ss DD/MM/YYYY',
  );
  const time = expiredAt.valueOf() - startTime.valueOf();
  const { timeRemaining } = useCountDown({
    time: time < 0 ? 0 : time,
    interval: 1000,
    startTime: startTime.valueOf(),
  });
  const { minutes, seconds, hours } = parseSecondsToMinutesAndHours(
    timeRemaining / 1000,
  );
  useEffect(() => {
    if (timeRemaining <= 0 && !isTimeout.current) {
      onTimeout && onTimeout();
      isTimeout.current = true;
    }
  }, [timeRemaining, onTimeout]);

  useEffect(() => {
    return () => {
      isTimeout.current = true;
    };
  }, []);
  return (
    <span style={{ color: '#E92127' }}>{`${hours < 10 ? '0' : ''}${hours}:${
      minutes < 10 ? '0' : ''
    }${minutes}:${seconds < 10 ? '0' : ''}${seconds}`}</span>
  );
};
